import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenu } from '../../form';
import { RankedCard } from './RankedCard';
import RankedRow from './RankedRow';
import { top10Gradients, worst10Gradients } from './Changes.config';
import { RankedAsset } from './index';

interface RankedDataWrapperProps {
  top: RankedAsset[];
  worst: RankedAsset[];
  width: number;
}

export const RankedDataWrapper = ({
  top,
  worst,
  width,
}: RankedDataWrapperProps) => {
  const { t } = useTranslation();
  const [currentlyShowing, setCurrentlyShowing] = useState<'top' | 'worst'>(
    'top'
  );
  const top10 = t('widget.priceChanges.top10');
  const worst10 = t('widget.priceChanges.worst10');

  if (width > 2) {
    return (
      <>
        <div
          className={`flex-1 h-full overflow-y-auto border-r border-grey-10 dark:border-grey-80`}
        >
          <div className="m-4 font-semibold text-lg text-grey-70 dark:text-grey-30">
            {top10}
          </div>
          <div className="flex items-end">
            {top.slice(0, 3).map((asset, index) => (
              <RankedCard
                key={asset.id + '_' + index}
                rank={index + 1}
                asset={asset}
                width={width}
                gradient={top10Gradients[index]}
              />
            ))}
          </div>
          <div>
            {top.slice(3).map((asset, index) => (
              <RankedRow
                key={asset.id + '_0_' + index}
                asset={asset}
                rank={index + 4}
              />
            ))}
          </div>
        </div>

        <div className={`flex-1 h-full overflow-y-auto`}>
          <div className="m-4 font-semibold text-lg text-grey-70 dark:text-grey-30">
            {worst10}
          </div>
          <div className="flex items-end">
            {worst.slice(0, 3).map((asset, index) => (
              <RankedCard
                key={asset.id + '_1_' + index}
                rank={index + 1}
                asset={asset}
                width={width}
                gradient={worst10Gradients[index]}
              />
            ))}
          </div>
          <div>
            {worst.slice(3).map((asset, index) => (
              <RankedRow
                key={asset.id + '_2_' + index}
                asset={asset}
                rank={index + 4}
              />
            ))}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className={`flex-1 h-full overflow-y-scroll`}>
      <DropdownMenu
        dropdownClassName="m-4 font-semibold text-lg text-grey-70 flex items-center"
        dropdownTooltipClassName={`bg-white border-solid border border-grey-10 -mt-3`}
        dropdownTooltipXOffset={8}
        dropdownTooltipYOffset={24}
        dropdownArrowClassName="-right-7 text-black mt-1"
        dropdownItems={[top10, worst10]}
        dropdownItemsData={['top', 'worst']}
        showArrow
        arrowPosition="right"
        handleClick={(_, choosen: 'top' | 'worst') =>
          setCurrentlyShowing(choosen)
        }
        hideOnItemClick
      >
        {currentlyShowing === 'top' ? top10 : worst10}
      </DropdownMenu>

      <div className="flex items-end">
        {(currentlyShowing === 'top' ? top : worst)
          .slice(0, 3)
          .map((asset, index) => (
            <RankedCard
              key={asset.id}
              rank={index + 1}
              asset={asset}
              width={width}
              gradient={
                currentlyShowing === 'top'
                  ? top10Gradients[index]
                  : worst10Gradients[index]
              }
            />
          ))}
      </div>
      <div>
        {(currentlyShowing === 'top' ? top : worst)
          .slice(3)
          .map((asset, index) => (
            <RankedRow key={asset.id + index} asset={asset} rank={index + 4} /> // TODO change this
          ))}
      </div>
    </div>
  );
};
